export default __webpack_public_path__ + "static/unbl_logo-d16f985aded7c893acbaee1fae4d0f10.svg";